import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Divider, InputAdornment, List, TextField, Typography } from '@mui/material';
import { IconSearch } from '@tabler/icons';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
  const theme = useTheme();

  // menu list collapse & items
  const items = item.children?.map((menu) => {
    switch (menu.type) {
      case 'collapse':
        return <NavCollapse key={menu.id} menu={menu} level={1} />;
      case 'item':
        return <NavItem key={menu.id} item={menu} level={1} />;
      default:
        return (
          <Typography key={menu.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return (
    <>
      <List
        subheader={
          item.title && (
            <>
              <Typography variant="caption" sx={{ ...theme.typography.menuCaption }} display="block" gutterBottom>
                {item.title}
                {item.caption && (
                  <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                    {item.caption}
                  </Typography>
                )}
              </Typography>
              {item.search && (
                <Box sx={{ px: 2, pb: 1 }}>
                  <TextField
                    size="small"
                    fullWidth
                    value={item.search.value}
                    onChange={(event) => item.search.onChange(event.target.value)}
                    placeholder="Buscar datapoint por nombre o code_id"
                    inputProps={{ 'aria-label': 'Buscar datapoint por nombre o code_id' }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <IconSearch size={18} />
                        </InputAdornment>
                      )
                    }}
                  />
                </Box>
              )}
            </>
          )
        }
      >
        {items}
      </List>

      {/* group divider */}
      <Divider sx={{ mt: 0.25, mb: 1.25 }} />
    </>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object
};

export default NavGroup;
